import { USER_INFO } from '../actions/actions';

const initialUser = {
    /* detail of loginned user */
    userInfo: {},
    token: {}
};

const userReducer = (state = initialUser, action) => {
    switch (action.type) {
        case USER_INFO:
            return {
                ...state,
                userInfo: action.data.userInfo,
                token: action.data.token
            }
        default:
            return state;
    }
}

export default userReducer;